@use "~theme/typography";

.container {
  padding: 28px 28px 32px;
}

.input {
  width: 100%;
  margin-bottom: 12px;

  input {
    text-align: center;
  }
}

.header {
  @include typography.heading3;
  margin-top: 0;
}

.form {
  margin: 0 auto;
  display: flex;
  max-width: 204px;
  flex-wrap: wrap;
}

.icon {
  text-align: center;
  padding-top: 16px;
}

.prompt {
  @include typography.body-semibold;
  color: var(--blue-01);
  text-align: center;
}

.codeError {
  text-align: center;
}

.emptyError {
  min-height: 8px;
}

.sendNewCode {
  text-align: center;
  margin-top: 24px;

  @include typography.body-link;
}

.phoneNumber {
  white-space: nowrap;
}
